import { Injectable } from '@angular/core';
import { HttpRestService } from '@core/services/http-rest.service';
import { APIResultData } from '@yourcause/common';
import { MyInvitationFromApi } from './my-invitations.typing';

@Injectable({ providedIn: 'root' })
export class MyInvitationsResources {

  constructor (
    private http: HttpRestService
  ) { }

  getMyInvitations (): Promise<APIResultData<MyInvitationFromApi>> {
    const endpoint = 'api/portal/applications/invitations';

    return this.http.post(endpoint, {
      paginationOptions: {
        returnAll: true,
        retrieveTotalRecordCount: false,
        filterColumns: [],
        orFilterColumns: [],
        sortColumns: [],
        rowsPerPage: 100000,
        pageNumber: 0
      }
    });
  }

}
